import { NewsService } from "@/client";
import { useMutation } from "@tanstack/react-query";

function useDeleteNews() {
  return useMutation({
    mutationFn: NewsService.deleteNews,
  });
}

export { useDeleteNews };
